/** Tenants cut over to context-based (v2) sportsbook. Everyone else loads classic. */
export const CONTEXT_ARCHITECTURE_TENANT_UUIDS = new Set([
  // '0c17fe55-315e-4ee0-b4f6-1364c8557dd1', // WombBigi
  // '9e6b7d4d-c3ea-4ec2-b8fb-5c3dc71efe5d', // Damagi

  '10bbca82-1cc5-40a9-94b7-db5cd6f5b448', // Bet at Home
  'd74df08e-e0d9-4972-8b5b-cc6a46cf0c4e', // Bet at Home Dev

  '10b11b9e-6c69-48f3-a9e0-392ad0d61037', // Bet at Home DE
  '2c5f30b2-d7d7-498f-abef-02ef4667cf0d', // Bet at Home DE Dev
]);

export function usesContextArchitecture(tenantId: string): boolean {
  return CONTEXT_ARCHITECTURE_TENANT_UUIDS.has(tenantId);
}
